import { formateProducts } from '../util/formateProduct';
import send from '../util/request';

export function requestAddProduct(saleId, num, unit, type = 1) {
  // 1 采购 2计划
  return send({ url: '/ipp/user-cart/insert', method: 'POST', data: { sale_id: saleId, number: num, unit, type }, });
}

export function requestModifyProduct(cartId, num, type = 1) {
  return send({ url: '/ipp/user-cart/update', method: 'POST', data: { cart_id: cartId, number: num, type }, });
}

export function requestRemoveProduct(cartIds, type = 1) {
  return send({ url: '/ipp/user-cart/delete', method: 'GET', params: { cart_ids: cartIds.join(','), type }, });
}

export function requestCartInfo(callback, type = 1) {
  return send({ url: '/ipp/user-cart/select', method: 'GET', params: { type }, options: { loading: true } }).then(res => {
    const { status, data: { data: { list = [] } } } = res;
    if (+status === 200) {
      callback(formateProducts(list));
    }
  });
}
